import type { IntegrationProvider } from './types';

const gmailProvider: IntegrationProvider = {
  key: 'gmail',
  label: 'Gmail',
  capabilities: {
    supportsFieldMapping: false,
    supportsRoleMapping: false,
    supportsRelationshipMapping: false,
    supportsWriteback: false,
  },
  flowKeys: {
    firstSync: {
      accounts: '',
      contacts: '',
      companies: '',
      conversation_messages: 'first-sync-for-emails',
    },
    receive: {
      accounts: '',
      contacts: '',
      companies: '',
      conversation_messages: 'receive-email-events',
    },
    send: {
      accounts: '',
      contacts: '',
      companies: '',
      conversation_messages: '',
    },
  },
  supportedObjects: ['conversation_messages'],
  activatableObjects: ['conversation_messages'],
  defaultSourceCollections: {
    conversation_messages: 'emails',
  },
};

export default gmailProvider;
